import { ArrowForwardIosSharp } from '@mui/icons-material'
import { AccordionSummaryProps, AccordionSummary as MuiAccordionSummary } from '@mui/material'
import { styled } from '@mui/system'
import { Accordion, AccordionDetails, Stack, Switch, Typography } from '@vapor/material'
import { TSCookies } from './cookie.types'

type CookieOptionProps = {
  value?: boolean
  title: string
  description: JSX.Element | string
  mandatory?: boolean
  onChange: (value: boolean) => void
}

const AccordionSummary = styled((props: AccordionSummaryProps) => <MuiAccordionSummary expandIcon={<ArrowForwardIosSharp sx={{ fontSize: '0.9rem' }} />} {...props} />)(({ theme }) => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(-90deg)',
  },
  backgroundColor: '#f2f5f8',
}))

export const CookieOption = (props: CookieOptionProps) => {
  const { title, description, value, mandatory, onChange } = props
  return (
    <Accordion>
      <AccordionSummary>
        <Stack direction="row" sx={{ pl: 2, justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
          <Typography variant="titleXSmall">
            <strong>{title}</strong>
          </Typography>
          {!mandatory && (
            <Switch
              checked={value ?? false}
              onChange={(e, v) => onChange(v)}
              onClick={(e) => {
                e.stopPropagation()
              }}
            />
          )}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body">{description}</Typography>
      </AccordionDetails>
    </Accordion>
  )
}
